(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hero-marque"] && !Shopify.designMode) return;
  try {
    
       $("#marqueeUp, #marqueeUp2").marquee({
direction: 'up',
startVisible: true,
speed: 5,
duplicated: true,
gap:0,
delayBeforeStart: 0,
            });
$("#marqueeDown").marquee({
direction: 'down',
startVisible: true,
speed: 5,
duplicated: true,
gap:0,
delayBeforeStart: 0,
            });
// typewriter 
  const words = ['Enthusiast.', 'Racer.'];
  const textEl = document.querySelector('.typewriter_text');
  let wordIndex = 0;
  let charIndex = 0;
  let isDeleting = false;
  let typingSpeed = 150;

  function type() {
    const currentWord = words[wordIndex];
    const currentText = currentWord.substring(0, charIndex);
    textEl.textContent = currentText;

    if (!isDeleting && charIndex < currentWord.length) {
      charIndex++;
      typingSpeed = 150;
    } else if (isDeleting && charIndex > 0) {
      charIndex--;
      typingSpeed = 80;
    } else if (!isDeleting && charIndex === currentWord.length) {
      isDeleting = true;
      typingSpeed = 1000;
    } else if (isDeleting && charIndex === 0) {
      isDeleting = false;
      wordIndex = (wordIndex + 1) % words.length;
      typingSpeed = 500;
    }

    setTimeout(type, typingSpeed);
  }

  type();

  } catch(e) { console.error(e); }
})();
})();
